export default "__VITE_ASSET__fDRetI01__"